import React from "react";
import Styles from "./Hamburger.module.scss";
import classNames from "classnames";

const Close = () => {
  const [test, setTest] = React.useState(true);
  return (
    <div className={Styles.close}>
      <span className={classNames(Styles["close__line--right"])}></span>
      <span className={Styles["close__line--left"]}></span>
    </div>
  );
};

export default Close;
